// Generated by purs version 0.15.0
import * as Data_Function from "../Data.Function/index.js";
import * as Data_Functor from "../Data.Functor/index.js";
import * as Data_Functor_Contravariant_Compat from "../Data.Functor.Contravariant.Compat/index.js";
import * as Data_Maybe from "../Data.Maybe/index.js";
import * as Data_Semigroup from "../Data.Semigroup/index.js";
import * as Effect from "../Effect/index.js";
import * as Specular_Callback from "../Specular.Callback/index.js";
import * as Specular_Dom_Builder from "../Specular.Dom.Builder/index.js";
import * as Specular_Dom_Element from "../Specular.Dom.Element/index.js";
import * as Specular_FRP_Base from "../Specular.FRP.Base/index.js";
import * as Specular_FRP_Replaceable from "../Specular.FRP.Replaceable/index.js";
var whenNothingD = function (dyn) {
    return function (content) {
        return Specular_FRP_Replaceable.whenD(Specular_FRP_Base.monadFRP(Specular_Dom_Builder.monadEffectBuilder)(Specular_Dom_Builder.monadCleanupBuilder))(Specular_Dom_Builder.monadReplaceBuilder)(Data_Functor.map(Specular_FRP_Base.functorDynamic)(Data_Maybe.isNothing)(dyn))(content);
    };
};
var onSubmitPreventDefault_ = function (cb) {
    return Specular_Dom_Element.on("submit")(Data_Semigroup.append(Data_Semigroup.semigroupFn(Effect.semigroupEffect(Data_Semigroup.semigroupUnit)))(Specular_Dom_Element.preventDefault)(Data_Functor_Contravariant_Compat.cvoid(cb)));
};
var onClickPreventDefault_ = function (cb) {
    return Specular_Dom_Element.onClick(Data_Semigroup.append(Data_Semigroup.semigroupFn(Effect.semigroupEffect(Data_Semigroup.semigroupUnit)))(Specular_Dom_Element.preventDefault)(Data_Functor_Contravariant_Compat.cvoid(cb)));
};
var gateEvent = function (dyn) {
    return function (event) {
        return Specular_FRP_Base.filterJustEvent(Specular_FRP_Base.attachDynWith(function (dynValue) {
            return function (evt) {
                if (dynValue) {
                    return new Data_Maybe.Just(evt);
                };
                return Data_Maybe.Nothing.value;
            };
        })(dyn)(event));
    };
};
var gateCallback = function (dyn) {
    return function (cb) {
        return Specular_Callback.contramapCallbackDynMaybe(Data_Functor.map(Specular_FRP_Base.functorDynamic)(function (v) {
            if (v) {
                return Data_Maybe.Just.create;
            };
            return Data_Function["const"](Data_Maybe.Nothing.value);
        })(dyn))(cb);
    };
};
export {
    whenNothingD,
    onClickPreventDefault_,
    gateEvent,
    gateCallback,
    onSubmitPreventDefault_
};
//# sourceMappingURL=index.js.map
